import { ITag } from "@fluentui/react";

import { DropdownOption } from "../DropdownOption";

export const mapToTag = (option: DropdownOption): ITag => {
    return {
        key: option.key,
        name: option.text
    };
};
